import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'

import { FloorCard } from '../../../../components/FloorCard'
import { TradeSessionCarousel } from '../../../../components/TradeSessionCarousel'
import { TRADE_SESSION_LIST_PAGE_PATH } from '../../../TradeSession/List/constants/path'

export const TradeSessionCard = () => {
  return (
    <FloorCard
      bordered={false}
      title='竞价场次'
      extra={
        <NavigateButton newtab to={TRADE_SESSION_LIST_PAGE_PATH}>
          更多&gt;
        </NavigateButton>
      }
      style={{
        paddingInlineEnd: 0
      }}
    >
      <TradeSessionCarousel columns={2} rows={2} />
    </FloorCard>
  )
}
